import React, { useState } from "react";
import { graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import styles from "./styles";
import Grid from "@material-ui/core/Grid";
import { buildBlocks } from "../../../services/builder";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button/Button";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import axios from "axios";
import Link from "../../Link";
import { trackCareersForm } from "../../../services/gtm";
import arrowIcon from "../../../images/right-arrow.png";

const useStyles = makeStyles((theme) => styles(theme));

export const CgbFormCareersBlock = (props) => {
  const blocks = buildBlocks(
    props.innerBlocks,
    props.parentAttributes,
    props.pageContext
  );

  const classes = useStyles();

  const [formError, setFormError] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSending, setFormSending] = useState(false);

  const [careerType, setCareerType] = useState("");
  const [forename, setForename] = useState("");
  const [surname, setSurname] = useState("");
  const [location, setLocation] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [cvFile, setCvFile] = useState(null);
  const [message, setMessage] = useState("");
  const [optinVacancyUpdates, setOptinVacancyUpdates] = useState(false);
  const [recaptchaResponse, setRecaptchaResponse] = useState("");
  const [validationErrors, setValidationErrors] = useState([]);

  const submitForm = (event) => {
    // send
    setFormSending(true);
    let formData = new FormData();
    formData.append("role", careerType);
    formData.append("forename", forename);
    formData.append("surname", surname);
    formData.append("location", location);
    formData.append("email", email);
    formData.append("telephone", telephone);
    formData.append("cv", cvFile);
    formData.append("message", message);
    formData.append("optinVacancyUpdates", optinVacancyUpdates);
    formData.append("g-recaptcha-response", recaptchaResponse);

    axios({
      method: "post",
      url: `${process.env.GATSBY_FORM_ENDPOINTS_URL}${process.env.GATSBY_FORM_ENDPOINTS_WEBSITE_NAME}/brand-careers`,
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then((response) => {
        if (Boolean(response.data.success)) {
          trackCareersForm(careerType);
          setFormSubmitted(true);
        }
        setFormSending(false);
      })
      .catch((error) => {
        let errorMessage = "There was a problem submitting your message. Please try again later.";
        if (error.hasOwnProperty("response")) {
          if (error.response) {
            console.log("Response", error.response);
            if (error.response.data.hasOwnProperty("message")) {
              errorMessage = error.response.data.message;
              setValidationErrors([]);
            } else if (error.response.data.hasOwnProperty("validation")) {
              setValidationErrors(error.response.data.validation);
              errorMessage = "Please check the form for errors.";
            }
          } else if (error.request) {
            console.log("Request", error.request);
          } else {
            console.log("Setup", error.message);
          }
        }
        setFormError(errorMessage);
        setFormSending(false);
      });
  };

  if (typeof window !== "undefined") {
    const urlParameters = new URLSearchParams(window.location.search);
    const paramType = urlParameters.get("type");
    if (paramType && careerType === "") {
      setCareerType(paramType);
    }
  }

  return (
    <div
      className={`contact-form ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.careersForm} ${classes.careersFormTheme}`}
    >
      {formSubmitted && (
        <p className={classes.thanks}>
          <CheckCircleIcon /> Thank you for your submission.
        </p>
      )}

      {!formSubmitted && formError.length != 0 && (
        <p className={classes.errors}>
          <WarningIcon /> {formError}
        </p>
      )}
      {!formSubmitted && (
        <form>
          <Grid container direction="row" justify="center">
            <Grid item xs={12}>
              {blocks.map((block) => {
                return block;
              })}
            </Grid>
            <Grid item xs={12} md={5} lg={4}>
              <label htmlFor="f-name" className={classes.label}>
                First Name
              </label>
              <TextField
                id="f-name"
                variant="outlined"
                className={`${classes.inputs} ${
                  validationErrors.forename ? "has-error" : ""
                }`}
                placeholder="Frederic"
                onChange={(e) => setForename(String(e.target.value))}
                aria-required={true}
                aria-invalid={Boolean(validationErrors.forename)}
              />
              {validationErrors.forename && (
                <p className={classes.validationError}>
                  {validationErrors.forename}
                </p>
              )}
              <label htmlFor="s-name" className={classes.label}>
                Last Name
              </label>
              <TextField
                id="s-name"
                variant="outlined"
                className={`${classes.inputs} ${
                  validationErrors.surname ? "has-error" : ""
                }`}
                placeholder="Robinson"
                onChange={(e) => setSurname(String(e.target.value))}
              />
              {validationErrors.surname && (
                <p className={classes.validationError}>
                  {validationErrors.surname}
                </p>
              )}

              <label htmlFor="location" className={classes.label}>
                Your location
              </label>
              <TextField
                id="location"
                variant="outlined"
                className={`${classes.inputs} ${
                  validationErrors.location ? "has-error" : ""
                }`}
                placeholder=""
                onChange={(e) => setLocation(String(e.target.value))}
              />
              {validationErrors.location && (
                <p className={classes.validationError}>
                  {validationErrors.location}
                </p>
              )}

              <label htmlFor="email" className={classes.label}>
                Email Address
              </label>
              <TextField
                id="email"
                variant="outlined"
                className={`${classes.inputs} ${
                  validationErrors.email ? "has-error" : ""
                }`}
                placeholder="Frederic.Robinson@email.com"
                onChange={(e) => setEmail(String(e.target.value))}
              />
              {validationErrors.email && (
                <p className={classes.validationError}>
                  {validationErrors.email}
                </p>
              )}
              <label htmlFor="tel" className={classes.label}>
                Phone Number
              </label>
              <TextField
                id="tel"
                variant="outlined"
                className={`${classes.inputs} ${
                  validationErrors.telephone ? "has-error" : ""
                }`}
                placeholder="07788 255 369"
                onChange={(e) => setTelephone(String(e.target.value))}
              />
              {validationErrors.telephone && (
                <p className={classes.validationError}>
                  {validationErrors.telephone}
                </p>
              )}

              <label htmlFor="careerType" className={classes.label}>
                What type of career are you interested in?
              </label>
              <select
                id="careerType"
                variant="outlined"
                className={`select ${classes.inputs} ${
                  validationErrors.careerType ? "has-error" : ""
                }`}
                placeholder="Frederic"
                onChange={(e) => setCareerType(String(e.target.value))}
                defaultValue={careerType}
                aria-required={true}
                aria-invalid={Boolean(validationErrors.careerType)}
              >
                <option value="Please select">Please select...</option>

                <option value="Pub careers">Pub careers</option>
                <option value="Support office careers">
                  Support office careers
                </option>
                <option value="Careers with beer">Careers with beer</option>
              </select>
              {validationErrors.role && (
                <p className={classes.validationError}>
                  {validationErrors.role}
                </p>
              )}

              <label htmlFor="cv" className={classes.label}>
                Upload your CV
              </label>
              <div className="cv-upload-wrap">
                <Button
                  variant="contained"
                  component="label"
                  className={`${classes.button} cv-upload`}
                >
                  { cvFile ? cvFile.name : "Upload your CV"}
                  <input
                    type="file"
                    hidden
                    onChange={(e) => {
                      setCvFile(e.target.files[0]);
                    }}
                  />
                </Button>
              </div>
              {validationErrors.cv && (
                <p className={classes.validationError}>{validationErrors.cv}</p>
              )}
            </Grid>
            <Grid item md={1} />
            <Grid item xs={12} md={5} lg={4}>
              <label htmlFor="message" className={classes.label}>
                Message
              </label>
              <TextField
                id="message"
                variant="outlined"
                className={`${classes.inputs} ${
                  validationErrors.message ? "has-error" : ""
                }`}
                placeholder="Please let us know what role you are interested in and the location you're interested in working"
                onChange={(e) => setMessage(String(e.target.value))}
                multiline
              />
              {validationErrors.message && (
                <p className={classes.validationError}>
                  {validationErrors.message}
                </p>
              )}

              <label htmlFor="optin_vacancy_updates" className={classes.label}>
                <input
                  type="checkbox"
                  id="optin_vacancy_updates"
                  className={classes.Input}
                  name="optin_vacancy_updates"
                  required
                  checked={optinVacancyUpdates}
                  onChange={(e) => setOptinVacancyUpdates(e.target.checked)}
                />
                <span className="checkmark"></span>
                Opt in to job vacancy updates
              </label>
              {validationErrors.optinVacancyUpdates && (
                <p className={classes.validationError}>
                  {validationErrors.optinVacancyUpdates}
                </p>
              )}

              <p className="{classes.label}">
                See our <Link to="/privacy-policy/">Privacy Policy</Link> for
                full details of how we process your personal data.
              </p>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={formSending}
                onClick={(event) => submitForm(event)}
              >
                Submit{" "}
                <img src={arrowIcon} alt="Search" width={14} height={15} />
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </div>
  );
};

export const CgbFormCareersBlockFragment = graphql`
  fragment CgbFormCareersBlock on WpBlock {
    ... on WpCgbFormCareersBlock {
      name
      attributes {
        className
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFormCareersBlockPreview = `
    ... on CgbFormCareersBlock {
        name
        attributes {
            className
        }
    }
`;
